import { validateAcls } from '@redviking/argonaut-core-ui/src/auth';
import type { ValidationResult } from 'types';
import type { ScheduleEntity } from './schedule.entity';

export function validateCalendarSelectAcl (): boolean {
    return validateAcls([ 'calendar_select' ]);
}
export function validateCalendarUpdateAcl (): boolean {
    return validateAcls([ 'calendar_update' ]);
}

export const validateSchedule = (schedule: ScheduleEntity['schedule']): ValidationResult => {
    if (!schedule.name || schedule.name.length <= 0) {
        return {
            status: 'error',
            errorMessage: 'Schedule missing "name" property',
        };
    }
    return {
        status: 'success',
    };
};
